$(function() {

    $.stats = {};

    // durations

    $.stats.duration = '50%';

    $.stats.pinDuration = 0;

    $.stats.endDuration = '50%';

    // timelines

    $.stats.tl = {};

    // in

	$.stats.tl.in = new TimelineMax();

    $.stats.tl.in.addLabel('start');
    $.stats.tl.in.addLabel('content', 2);

    $.stats.tl.in.set('#stats-section', { visibility: 'visible' }, 'start');

    $.stats.tl.in.fromTo('#stats-section .stats-background', 1, { opacity:0 }, { opacity:1 }, 'start');

    new ScrollMagic.Scene({ triggerElement: '#stats-section. stats-pin', triggerHook: 'onEnter', duration: $.stats.duration })
    	.setTween($.stats.tl.in)
    	// .addIndicators({name: 'stats in'})
        .addTo($.controller);

    new ScrollMagic.Scene({ triggerElement: '#stats-section .stats-pin', triggerHook: 'onLeave', duration: $.stats.pinDuration })
        .setPin('#stats-section .stats-background')
        // .addIndicators({name: 'stats pin'})
        .addTo($.controller);

    /*

    $.stats.tl.out = new TimelineMax();

    $.stats.tl.out.addLabel('start');

    $.stats.tl.out.to('#stats-section .stats-background', 1, { opacity:0 }, 'start');
    $.stats.tl.out.set('#stats-section .stats-background', { visibility:'hidden', delay:1 }, 'start');

    new ScrollMagic.Scene({ triggerElement: '#stats-section .stats-trigger', triggerHook: 'onCenter', duration: $.stats.endDuration })
        .setTween($.stats.tl.out)
        // .addIndicators({name: 'stats out'})
        .addTo($.controller);

    */

});
